import { useTranslation } from 'react-i18next'
import type { AgentMission } from '../../api/schema'

/** What the run's mission does: its title and description, as the launch dialog shows them. */
export function AgentRunMission({ code, mission }: { code: string; mission?: AgentMission }) {
    const { t } = useTranslation('agent-runs')
    const description = mission ? t(mission.description_key, { defaultValue: '' }) : ''
    return (
        <div className="grid grid-cols-[10rem_1fr] gap-2 py-1 text-sm" data-testid="agent-run-mission">
            <dt className="text-muted-foreground">{t('page.mission')}</dt>
            <dd className="min-w-0 break-words text-foreground">
                <span className="font-medium">{mission ? t(mission.title_key, { defaultValue: mission.code }) : code}</span>
                {description && (
                    <p className="text-muted-foreground" data-testid="agent-run-mission-description">{description}</p>
                )}
            </dd>
        </div>
    )
}
